import classNames from "classnames";
import React, { useContext } from "react";
import RadioGroupContext from "./context";
import styles from "./index.module.css";
import { RadioProps } from "./interface";

const InternalRadio: React.FC<RadioProps> = (props) => {
  const { value, checked, label, disabled } = props;
  const context = useContext(RadioGroupContext);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(e);
    context?.onChange?.(e);
  };

  return (
    <label
      className={classNames(styles.radio, {
        [styles.radioDisabled]: disabled,
      })}
      id={
        value === "delivery"
          ? "checkout-delivery-radio"
          : value === "pickup"
          ? "checkout-pickup-radiot"
          : ""
      }
      data-testid={
        value === "delivery"
          ? "checkout-delivery-radio"
          : value === "pickup"
          ? "checkout-pickup-radiot"
          : ""
      }
    >
      <input
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span
        className={classNames("ml-3", {
          "font-bold": checked,
        })}
      >
        {label}
      </span>
    </label>
  );
};

export default InternalRadio;
